import KitsForm from '@/components/Operational/Kits/KitsForm';
import { SaveButton, TabContentWrapper } from '@/components/_common';
import ButtonBack from '@/components/_common/ButtonBack';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import { useCreateKit } from '@/core/domain/operational/Kits/Kits.hooks';
import {
  CreateKitRequest,
  KitCreateFormValues,
  KitItemCreate,
} from '@/core/domain/operational/Kits/Kits.types';
import Authorities from '@/types/Authority';
import { PageProps } from '@/types/PageProps';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Divider, Form } from 'antd';
import React, { createContext, useContext, useState } from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';

interface KitItemsContextProps {
  items: KitItemCreate[];
  setItems: React.Dispatch<React.SetStateAction<KitItemCreate[]>>;
}

const KitItemsContext = createContext({} as KitItemsContextProps);
export const useKitItemsContext = () => useContext(KitItemsContext);

const KitsCreatePage: React.FC<PageProps> = ({ route }) => {
  const history = useHistory();
  const intl = useIntl();
  const [form] = Form.useForm<KitCreateFormValues>();
  const [items, setItems] = useState<KitItemCreate[]>([]);

  const { isLoading: loadingCreate, mutateAsync: createKitMutate } =
    useCreateKit();

  async function handleCreate() {
    const values = await form.validateFields();

    const obj: CreateKitRequest = {
      description: values.description,
      increaseDecrease: values.increaseDecrease,
      items: items.map((item) => ({
        itemId: item.itemId,
        itemType: item.itemType,
        quantity: item.quantity,
        kitDiscount: item.companies.map((company) => ({
          id: company.id,
          companyId: company.companyId,
          increaseDecrease:
            typeof company.increaseDecrease === 'number'
              ? company.increaseDecrease
              : 0,
        })),
      })),
    };

    const kit = await createKitMutate(obj);

    history.push(`/app/operational/kits/${kit.id}`);
  }

  return (
    <KitItemsContext.Provider
      value={{
        items,
        setItems,
      }}
    >
      <TabContentWrapper
        title={route.name}
        permissions={route.permissions}
        extra={
          <SaveButton
            block
            type="primary"
            onClick={handleCreate}
            loading={loadingCreate}
            disabled={!hasPermissions([Authorities.KITS_REGISTRATION])}
          >
            {intl.formatMessage({ id: 'commons.form.button.save' })}
          </SaveButton>
        }
      >
        <Form form={form}>
          <KitsForm />
        </Form>

        <Divider />

        <SpaceForButton>
          <ButtonBack path="/app/operational/kits" />
        </SpaceForButton>
      </TabContentWrapper>
    </KitItemsContext.Provider>
  );
};

export default KitsCreatePage;
